export default "__VITE_ASSET__0eOvlKAB$ygKBkFBiA0Vvg__"